// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__jcQyq","containerItemsCenter":"Skeleton_containerItemsCenter__3G_6E"};